import { lazyImport } from "@/lazy-import";

const { AuthRoutes } = lazyImport(
  () => import("../features/auth"),
  "AuthRoutes",
);

const { PairRoutes } = lazyImport(
  () => import("../features/pair"),
  "PairRoutes",
);

const { EnrollRoutes } = lazyImport(
  () => import("../features/enroll"),
  "EnrollRoutes",
);

export const publicRoutes = [
  {
    path: "/auth/*",
    element: <AuthRoutes />,
  },
  {
    path: "/pair/*",
    element: <PairRoutes />,
  },
  {
    path: "/enroll/*",
    element: <EnrollRoutes />,
  },
];
